import { FC } from 'react'
import styled from 'styled-components'

interface ButtonTypes {
    type: 'button' | 'submit' | 'reset'
    disabled?: boolean
}

const Button: FC<ButtonTypes> = ({ children, type, disabled }) => {
    return (
        <Btn type={type} disabled={disabled}>
            {children}
        </Btn>
    )
}

const Btn = styled.button`
    width: 100%;
    background: #7f55ff;
    opacity: 0.9;
    border-radius: 5px;
    min-height: 48px;
    min-width: 192px;
    padding: 0 20px;
    font-size: 15px;
    font-weight: bold;
    color: #fff;
    transition: 0.3s all ease;
    &:hover {
        opacity: 1;
    }
`

export { Button }
